import { useState, useCallback, useEffect } from 'react';

const STORAGE_KEY = 'limecraft_recent_emails';
const MAX_HISTORY = 20;

export const useRecentEmails = () => {
    const [recentEmails, setRecentEmails] = useState<string[]>([]);

    useEffect(() => {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
            try {
                setRecentEmails(JSON.parse(stored));
            } catch (e) {
                console.error('Failed to parse recent emails', e);
            }
        }
    }, []);

    const addEmailsToHistory = useCallback((newEmails: string[]) => {
        setRecentEmails((prev) => {
            const combined = [...newEmails, ...prev];
            const unique = Array.from(new Set(combined)).slice(0, MAX_HISTORY);

            localStorage.setItem(STORAGE_KEY, JSON.stringify(unique));
            return unique;
        });
    }, []);

    return { recentEmails, addEmailsToHistory };
};
